<template>
  <div id="main">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
import YunJi from "common/js/YunJi.js";
import { uuid } from 'common/js/Util.js'

export default {
  name: 'commodity',
  data () {
    return {
      include: [],       //需要缓存的页面，输出对应的页面name
      appCont: YunJi.getUrlParams('appCont'),
      shopId: YunJi.getUrlParams('shopId')
    }
  },
  mounted() {
    this.initThinkingReport(); // 初始化数数埋点
  },
  methods: {
    /**
    * 数据上报
    */
    initThinkingReport() {
      let appId = "";
      if (globalConfig.buyerBasePath.startsWith("m.yunji") || globalConfig.buyerBasePath.startsWith("m-ga.yunji")) {
        // 正式
        if (this.appCont == 0) {
          appId = "ba036c847ebf492ab5dcef1de530b44e";
        } else if (this.appCont == 1 || (YunJi.appUA && YunJi.appUA.identity_type)) { // identity_type有值则为app合并，app合并就将点报在卖家版表里
          appId = "48df4d00dffb488889293dc20521e31d";
        } else if (this.appCont == 2) {
          appId = "f0edd6e68c6949da94a4a8ae3678b0f7";
        } else if (this.appCont == 7) { // identity_type有值则为app合并，app合并就将点报在卖家版表里
          appId = "51040442586f4223b5fb075d4ffd5f74";
        }
      } else {
        // 测试
        if (this.appCont == 0) {
          appId = "587f69909c9749ac8f98562527e948a2";
        } else if (this.appCont == 1 || (YunJi.appUA && YunJi.appUA.identity_type)) { // identity_type有值则为app合并，app合并就将点报在卖家版表里
          appId = "78cbafbbb0a94edb85126bf7350c198e";
        } else if (this.appCont == 2) {
          appId = "2cf61875c9f9487c968e9da49102b71b";
        } else if (this.appCont == 7) { // 小程序套h5 埋点
          appId = "5eca5fe77a054873814b6a178b04d007";
        }
      }
      (function(param) {
        var p = param.sdkUrl,
          n = param.name,
          w = window,
          d = document,
          s = "script",
          x = null,
          y = null;
        w["ThinkingDataAnalyticalTool"] = n;
        w[n] =
          w[n] ||
          function(a) {
            return function() {
              (w[n]._q = w[n]._q || []).push([a, arguments]);
            };
          };
        var methods = [
          "track",
          "quick",
          "login",
          "logout",
          "trackLink",
          "userSet",
          "userSetOnce",
          "userAdd",
          "userDel",
          "setPageProperty"
        ];
        for (var i = 0; i < methods.length; i++) {
          w[n][methods[i]] = w[n].call(null, methods[i]);
        }
        if (!w[n]._t) {
          (x = d.createElement(s)), (y = d.getElementsByTagName(s)[0]);
          x.async = 1;
          x.src = p;
          y.parentNode.insertBefore(x, y);
          w[n].param = param;
        }
      })({
        appId: appId, //系统分配的APPID
        name: "thinkingReport", //全局的调用变量名，可以任意设置，后续的调用使用该名称即可
        sdkUrl:"https://static.yunjiglobal.com/qnUpload/frontend/js/thinkingdata_1.0.5.js", //统计脚本URL
        serverUrl: "//ta.yunjiglobal.com/sync_js",
        send_method: 'ajax',
        showLog: false
      });
      if (this.appCont == 0) {
        // H5传的是consumer_id
        var consumer_id = YunJi.getCookie("burial_point_cid");
        var union_id = YunJi.getCookie("burial_point_wx_id");
        if (consumer_id) {
          thinkingReport.setPageProperty({ consumer_id: consumer_id });
        }
        if (union_id) {
          thinkingReport.login(union_id);
        } else {
          thinkingReport.logout();
        }
        thinkingReport.setPageProperty({
          link_shop_id: YunJi.getUrlParams("shopId")
        });
      } else if (this.appCont == 1 || this.appCont == 2 || this.appCont == 7 || (YunJi.appUA && YunJi.appUA.identity_type)) { // identity_type有值则为app合并，app合并就将点报在卖家版表里
        if(this.appCont == 1){
          // 卖家版传的是shopId
          if (YunJi.appUA.shop_id && YunJi.appUA.shop_id !== "null") {
            thinkingReport.login(YunJi.appUA.shop_id);
          } else if (YunJi.getUrlParams("shopId")) {
            thinkingReport.login(YunJi.getUrlParams("shopId"));
          } else {
            thinkingReport.logout();
          }
        }else if(this.appCont == 2){
          // vip传的是user_id  也就是 consumer_id
          if (YunJi.appUA.user_id && YunJi.appUA.user_id !== "null") {
            thinkingReport.login(YunJi.appUA.user_id);
          } else {
            thinkingReport.logout();
          }
        }else if(this.appCont == 7){
          // vip传的是user_id  也就是 consumer_id
          const ticket = YunJi.getUrlParams('ticket')
          // 优化埋点，不管有没有登录都带distinct_id，登陆了才使用consumerId login
          if (!localStorage.getItem('uuid')) {
            localStorage.setItem('uuid', uuid())
          }
          thinkingReport.setPageProperty({ distinct_id: `null${localStorage.getItem('uuid').replace(/-/g, '')}` })
          if (ticket != 'ticket|') {
            const consumerId = ticket.split('_')[1]
            thinkingReport.login(consumerId)
            thinkingReport.setPageProperty({ consumer_id: consumerId })
          } else {
            thinkingReport.logout()
          }
        }
        thinkingReport.setPageProperty({"#app_version": YunJi.appUA.appVersion});
        thinkingReport.setPageProperty({ "#os": YunJi.appUA.appClient });
        if(YunJi.appUA.identity_type){thinkingReport.setPageProperty({ "identity_type": YunJi.appUA.identity_type });}
        if(YunJi.appUA.mobile_id){thinkingReport.setPageProperty({ "mobile_id": YunJi.appUA.mobile_id });}
        if(YunJi.appUA.mobile_system){thinkingReport.setPageProperty({ "mobile_system": YunJi.appUA.mobile_system });}
        if(YunJi.appUA.mobile){thinkingReport.setPageProperty({ "mobile": YunJi.appUA.mobile });}
      }
    }
  }
}
</script>

<style lang="less">
@font-face {
  font-family: 'DINAlternate-Bold';
  src: url("../../assets/fonts/DIN Alternate Bold.ttf");
} 
</style>

